import styled, { css, keyframes } from 'styled-components';
import { Box } from 'modules/Box';
import { Typography } from 'modules/Typography';
import { pxToRem } from 'modules/spacing';
import { theme } from 'modules/tetrisTheme';
const BOTTOM_SPACING = theme.spacing.md;
export const Container = styled(Box) `
  position: fixed;
  left: 50%;
  bottom: 0;
  align-items: center;
  transform: translate(-50%, 0);
`;
function getTransitionCSS(state) {
    switch (state) {
        case 'visible':
            return css `
        transform: translate(0, 0);
      `;
        case 'entering':
        case 'leaving':
        case 'hidden':
            return css `
        transform: translate(0, calc(100% + ${BOTTOM_SPACING}));
      `;
        default:
            return undefined;
    }
}
export const Title = styled(Typography) ``;
export const Message = styled(Typography) ``;
function getAppearanceCSS(appearance) {
    switch (appearance) {
        case 'success':
            return css `
        ${Title} {
          color: ${theme.swatches.green[400]};
        }
      `;
        case 'danger':
            return css `
        ${Title} {
          color: ${theme.swatches.red[400]};
        }
      `;
        case 'info':
        default:
            return css `
        ${Title} {
          color: ${theme.semantic.foreground.inverse};
        }
      `;
    }
}
const backgroundBlurAnimation = keyframes `
  0% {
    backdrop-filter: blur(0);
  }
    
  100% {
    background-color: color-mix(in srgb, ${theme.semantic.surface.inverse}, transparent 7%);
    backdrop-filter: blur(${pxToRem(20)});
  }
`;
const background = css `
  background-color: ${theme.semantic.surface.inverse};
  animation-name: ${backgroundBlurAnimation};
  animation-duration: 0.2s;
  animation-fill-mode: forwards;
  animation-delay: 0.2s;
`;
export const ToastContainer = styled.div `
  display: flex;
  position: fixed;
  flex-direction: column;
  bottom: ${BOTTOM_SPACING};
  gap: ${theme.spacing.lg};
  min-width: 0;
  width: ${pxToRem(500)};
  padding: ${theme.spacing.xl};
  ${background};
  ${(props) => getTransitionCSS(props.$transitionState)};
  ${(props) => getAppearanceCSS(props.$appearance)};
  transition: all 0.2s ease-in-out;
  box-shadow: ${theme.dropShadow[300]}, ${theme.dropShadow[400]};
  border-radius: ${theme.borderRadius.md};

  ${Message} {
    color: ${theme.swatches.gray[100]};
  }
`;
